import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { OpenInNewRounded } from "@mui/icons-material";
import { MdOutlinedFlag, MdOutlineEventSeat } from "react-icons/md";
import { Box, ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { MLBAdobeScriptHeader } from "@/global/common/mlb-common/MLBAdobeScriptHeader";

export const TampaBayRaysLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://www.mlb.com/rays/tickets/my-tickets"
  >
    MyTickets
  </Link>
);

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose your games.",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Connect your MLB.com account",
    description:
      "Click Continue and connect your Tampa Bay Rays account using our secure MLB.com login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Suite",
    description: "Select the suite you wish to purchase for your game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your MLB Ballpark app or by logging into
        your account via{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="http://www.raysbaseball.com/myaccount"
        >
          http://www.raysbaseball.com/myaccount
        </Link>
        .
      </>
    ),
  },
];

export const faqs = [
  {
    title: "Is catering included in my suite?",
    description:
      "Catering is included. Catering package includes Hot Dogs, Chicken Tenders, Bavarian Pretzels, Salsa & Guacamole, Bottomless Popcorn, Snack Attack, Salad, Cookies, Water and Coca-Cola Products. Upon completing your purchase, a Rays representative will reach out to connect you with the catering manager should you wish to upgrade your catering menu.",
  },
  {
    title: "When will I receive my tickets?",
    description:
      "Once you checkout and complete your purchase, the tickets and parking passes will be available in the MLB Ballpark app using the same email as your reservation.",
  },
  {
    title: "How do I forward my tickets and parking passes to my guests?",
    description: (
      <>
        Please visit{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="http://www.raysbaseball.com/mobile"
        >
          http://www.raysbaseball.com/mobile
        </Link>{" "}
        for step by step directions on how to access and forward tickets via the
        MLB Ballpark app.
      </>
    ),
  },
];

export const TampaBayRaysCheckoutTerms = () => (
  <>
    In connection with your reservation, you will receive ticket-related
    commercial emails from raysbaseball.com. You may unsubscribe at any time. By
    checking this box you agree to receive additional commercial emails from
    raysbaseball.com and mlb.com. The terms and conditions of your ticket and
    policies applicable to its use are available online at{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.mlb.com/rays/tickets/disclaimer"
    >
      Tampa Bay Rays Ticket Terms & Conditions
    </Link>
    . By clicking the Purchase Tickets button, you agree to accept all Terms and
    Conditions. Once your purchase is complete, a Tampa Bay Rays representative
    will reach out to you directly to connect you with the catering manager.
    Upon completing your purchase, you acknowledge and agree that your credit
    card will be charged. By clicking &quot;Purchase Tickets&quot;, you agree to
    the MLB{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.mlb.com/app/ballpark/official-information/privacy-policy"
    >
      Privacy Policy
    </Link>
    ,{" "}
    <Link
      target="_blank"
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://www.mlb.com/app/ballpark/official-information/terms-of-use"
    >
      Terms of Use
    </Link>
    . Tickets will be made available in the MLB Ballpark mobile application
    only. MLB.com | The Official Site of Major League Baseball and supported
    mobile device required.
  </>
);

export const TampaBayRaysAdditionalDetailsDisclaimerTC = () => (
  <>
    By entering my name, checking the box above and clicking checkout, I hereby
    (i) agree to the Terms of Use (ii) agree that my reservation is complete and
    all sales are final.
  </>
);

export const TampaBayRaysTCListItems = () => (
  <Box>
    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/privacy-policy",
          "_blank",
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Privacy Policy</ListItemText>
    </MenuItem>

    <MenuItem
      onClick={() => {
        window.open(
          "https://www.mlb.com/app/ballpark/official-information/terms-of-use",
          "_blank",
        );
      }}
    >
      <ListItemIcon>
        <OpenInNewRounded fontSize="small" />
      </ListItemIcon>
      <ListItemText>MLB Terms of Use</ListItemText>
    </MenuItem>
  </Box>
);

export const TampaBayRaysRegistrationTerms = () => (
  <>
    By creating an account you agree to be notified regarding your purchase and
    to the{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
    >
      Terms & Conditions
    </Link>{" "}
    and{" "}
    <Link
      target={"_blank"}
      sx={{
        fontWeight: 500,
        color: "primary.main",
        textDecoration: "none",
      }}
      href="https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
    >
      Privacy Policy
    </Link>
    .
  </>
);

export function AnalyticsHeader() {
  return (
    <>
      <MLBAdobeScriptHeader />
    </>
  );
}
